import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { FormikDatePicker } from 'globalcomponents/UI/Form/Base';
import { getDateLocale } from 'globalutils/fmUtils';
import { UI_DATE_LOWER_FORMAT } from 'globalconfig/constants/static';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));

const RenderComponent = ({ values, handleEdit, validateForm, submitAction, cancelAction }) => {
  const { i18n } = useTranslation();

  return (
    <>
      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="driver">
          {i18n.t('common.driver')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="driverName"
            handleOnChange={(event) => {
              handleEdit(event, { field: 'driverName' });
            }}
            id="driverName"
            as={Input}
            value={values.driverName}
            isClearable
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="vehicle">
          {i18n.t('common.vehicle')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="vehicleVin"
            handleOnChange={(event) => {
              handleEdit(event, { field: 'vehicleVin' });
            }}
            id="vehicleVin"
            as={Input}
            value={values.vehicleVin}
            isClearable
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="state">
          {i18n.t('common.state')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="state"
            handleOnChange={(event) => {
              handleEdit(event, { field: 'state' });
            }}
            id="state"
            as={Input}
            value={values.state}
            isClearable
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="startDate">
          {i18n.t('common.dateFrom')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            id="startDate"
            name="startDate"
            onChange={(event) => {
              handleEdit(event, { field: 'startDate', type: 'date' });
            }}
            locale={getDateLocale()}
            as={FormikDatePicker}
            placeholderText={UI_DATE_LOWER_FORMAT}
            value={values.startDate}
            showPopperArrow={false}
            showTimeSelect={false}
            maxDate={new Date()}
            showDisabledMonthNavigation
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            isClearable
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="endDate">
          {i18n.t('common.dateTo')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            id="endDate"
            name="endDate"
            onChange={(event) => {
              handleEdit(event, { field: 'endDate', type: 'date' });
            }}
            locale={getDateLocale()}
            as={FormikDatePicker}
            placeholderText={UI_DATE_LOWER_FORMAT}
            value={values.endDate}
            showPopperArrow={false}
            showTimeSelect={false}
            maxDate={new Date()}
            showDisabledMonthNavigation
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            isClearable
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.ButtonsWrapper className="vertical-button">
        <Button
          type="submit"
          label={i18n.t('common.view')}
          onClick={(e, d) => {
            const validateResponse = validateForm();
            validateResponse.then((data) => {
              submitAction(data);
            });
          }}
        />
        <Button
          className=""
          type={'reset'}
          label={i18n.t('common.clear')}
          onClick={() => {
            cancelAction();
          }}
        />
      </FormStyle.default.ButtonsWrapper>
    </>
  );
};

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  hasApiStatus: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};

export default RenderComponent;
